import { RetrieveDocumentsReferenceOutputDto } from '@api/ecommerce-xp';
import { useFetchBankRetrieveDocumentsReference } from '@services';
import { useServiceResponse } from '@store';

interface FetchDocumentOutput {
	base64BankDocument?: string;
	getDocumentBase64: (data: RetrieveDocumentsReferenceOutputDto | null | undefined) => string | undefined;
	fetchBankDocument: () => Promise<void>;
}

export const useFetchDocument = (): FetchDocumentOutput => {
	const { fetch: fetchRetrieveBankDocumentsReference } = useFetchBankRetrieveDocumentsReference();

	const { retrieveBankDocumentReference } = useServiceResponse();

	const getDocumentBase64 = (data: RetrieveDocumentsReferenceOutputDto | null | undefined): string | undefined => {
		return data?.documentList?.[0]?.document || undefined;
	};

	const fetchBankDocument = (): Promise<void> => {
		return new Promise((resolve) => {
			if (retrieveBankDocumentReference) {
				resolve();
			} else {
				fetchRetrieveBankDocumentsReference({}).then((res) => {
					getDocumentBase64(res.data);
					resolve();
				});
			}
		});
	};

	return {
		base64BankDocument: getDocumentBase64(retrieveBankDocumentReference),
		getDocumentBase64,
		fetchBankDocument,
	};
};
